import { useNavigate, useLocation } from "react-router-dom";
import { AuthBannerStoreImplementation } from "Data/AuthBanner/AuthBannerStoreImplementation";
import { UserAuthenticationStoreImplementation } from "Data/UserAuthentication/UserAuthenticationStoreImplementation";

export const AUTH_LOGIN_REQUIRED_MESSAGE =
  "Please log in to your account.";
export const AUTH_SESSION_EXPIRED_MESSAGE =
  "Your session has expired. Please log in again.";

export const useForceLogoutAndRedirect = () => {
  const userAuthStore = UserAuthenticationStoreImplementation();
  const authBannerStore = AuthBannerStoreImplementation();
  const navigate = useNavigate();
  const location = useLocation();

  return (message: string): void => {
    let currentPath: string | null = null;
    try {
      currentPath = location.pathname + location.search;
    } catch (err) {
      console.error("Failed to read current path", err);
    }
    try {
      userAuthStore.logUserOut();
    } catch (err) {
      console.error("Failed to log user out via store implementation", err);
    }
    try {
      authBannerStore.showBanner(message, currentPath);
    } catch (err) {
      console.error("Failed to show auth banner via store implementation", err);
    }
       try {
      if (location.pathname !== "/auth/login") {
        navigate("/auth/login", { replace: true });
      }
    } catch (err) {
      console.error("Failed to redirect to login", err);
    }
  };
};
